import { render, staticRenderFns } from "./PurchaseResult.vue?vue&type=template&id=545e8127&scoped=true&"
import script from "./PurchaseResult.vue?vue&type=script&lang=js&"
export * from "./PurchaseResult.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseResult.vue?vue&type=style&index=0&id=545e8127&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e8127",
  null
  
)

export default component.exports